<div class="container">

  <!-- Top Breadcrumbs Bar with Search & Filter on Right for Super Admin (List View) -->
  @if (isSuperAdmin && !selectedTicket) {
    <div class="ticket-breadcrumb-wrapper ticket-breadcrumb-flex">
      <div class="breadcrumb-left-side">
        <app-breadcrumb></app-breadcrumb>
      </div>

      @if (isSuperAdmin) {
        <div class="breadcrumb-right-actions">
          <!-- Search Bar on Right Side (Left of Filter) -->
          <form class="fd-top-search-form" autocomplete="off" role="search" (submit)="$event.preventDefault()" style="margin: 0; display: inline-flex;">
            <div class="fd-top-search-wrapper">
              <i class="fa fa-search fd-top-search-icon"></i>
              <input 
                type="search" 
                name="topSearchTicketsInput"
                id="topSearchTicketsInput"
                autocomplete="off"
                autocorrect="off"
                spellcheck="false"
                class="fd-top-search-input" 
                placeholder="Search tickets by ID, email, org..." 
                [(ngModel)]="ticketListSearchQuery" 
                (input)="onSearchChange()" />
              @if (ticketListSearchQuery) {
                <span class="fd-clear-search-btn" (click)="ticketListSearchQuery = ''; onSearchChange()">&times;</span>
              }
            </div>
          </form>

        <!-- Filter Button with Anchored 2-Column Popup -->
        <div class="fd-filter-anchor">
          <button class="fd-btn fd-btn-filter" [ngClass]="{'fd-btn-filter-active': appliedFilterCount > 0}" (click)="toggleFilterPopup()">
            <i class="fa fa-filter"></i> Filters {{ appliedFilterCount > 0 ? '(' + appliedFilterCount + ')' : '' }}
          </button>

          <!-- 2-Column Filter Dropdown Popup (Positioned directly below filter button) -->
          @if (showFilterPopup) {
            <div class="fd-filter-dropdown-menu" (click)="$event.stopPropagation()">
              <div class="fd-filter-dropdown-layout">
                
                <!-- Left Column: Filter Categories -->
                <div class="fd-filter-tabs-col">
                  @for (tab of filterTabs; track tab) {
                    <div 
                      class="fd-filter-tab-item" 
                      [ngClass]="{'active': selectedFilterTab === tab, 'applied': isFilterTabApplied(tab)}"
                      (click)="selectFilterTab(tab)">
                      {{ tab }}
                    </div>
                  }
                </div>

                <!-- Right Column: Filter Options -->
                <div class="fd-filter-content-col">

                  <!-- 1. Priority Tab -->
                  @if (selectedFilterTab === 'Priority') {
                    <div class="fd-filter-tab-body">
                      <div class="fd-filter-options-list">
                        @for (pr of ['Low', 'Medium', 'High', 'Urgent']; track pr) {
                          <label class="fd-checkbox-label">
                            <input 
                              type="checkbox" 
                              [checked]="tempFilters.priorities.includes(pr)" 
                              (change)="toggleTempPriority(pr)" />
                            <span class="fd-priority-dot" [ngStyle]="{'background-color': getPriorityDotColor(pr)}"></span>
                            <span>{{ pr }}</span>
                          </label>
                        }
                      </div>
                    </div>
                  }

                  <!-- 2. Status Tab -->
                  @if (selectedFilterTab === 'Status') {
                    <div class="fd-filter-tab-body">
                      <div class="fd-filter-options-list">
                        @for (st of ['Open', 'Pending', 'Resolved', 'Closed']; track st) {
                          <label class="fd-checkbox-label">
                            <input 
                              type="checkbox" 
                              [checked]="tempFilters.statuses.includes(st)" 
                              (change)="toggleTempStatus(st)" />
                            <span>{{ st }}</span>
                          </label>
                        }
                      </div>
                    </div>
                  }

                  <!-- 3. Created Date Tab -->
                  @if (selectedFilterTab === 'Created Date') {
                    <div class="fd-filter-tab-body">
                      <div class="fd-filter-radio-group">
                        <label class="fd-radio-label">
                          <input type="radio" name="dateOpt" [(ngModel)]="tempFilters.createdDateOption" value="is" />
                          <span>Is</span>
                        </label>
                        <label class="fd-radio-label">
                          <input type="radio" name="dateOpt" [(ngModel)]="tempFilters.createdDateOption" value="between" />
                          <span>Between</span>
                        </label>
                      </div>
                      <div class="fd-date-inputs-row">
                        <input type="date" class="fd-filter-input" [(ngModel)]="tempFilters.createdDateStart" />
                        @if (tempFilters.createdDateOption === 'between') {
                          <input type="date" class="fd-filter-input mt-2" [(ngModel)]="tempFilters.createdDateEnd" placeholder="End date" />
                        }
                      </div>
                    </div>
                  }

                  <!-- 4. Organization Tab -->
                  @if (selectedFilterTab === 'Organization' || selectedFilterTab === 'OrgName') {
                    <div class="fd-filter-tab-body">
                      <label class="fd-field-label">Select Organization</label>
                      <select class="fd-filter-select-input" [(ngModel)]="tempFilters.orgName">
                        <option value="">All Organizations</option>
                        @for (orgName of availableOrganizationsList; track orgName) {
                          <option [value]="orgName">{{ orgName }}</option>
                        }
                      </select>
                    </div>
                  }

                  <!-- Footer Actions -->
                  <div class="fd-filter-tab-actions">
                    <button type="button" class="fd-filter-clear-btn" (click)="clearCurrentTabFilter()">Clear</button>
                    <button type="button" class="fd-filter-apply-btn" (click)="applyFilterPopup()">Apply Filter</button>
                  </div>

                </div>

              </div>
            </div>
          }
        </div>

        <!-- Create Ticket Button for Super Admin -->
        <button type="button" class="fd-btn fd-btn-create-ticket" (click)="openCreateTicketModal()" id="btnCreateTicketSuperAdmin" title="Create New Ticket">
          <i class="fa fa-plus"></i> Create Ticket
        </button>
      </div>
    }
  </div>
}

  <!-- Custom Modal Popup for Ticket Form -->
  <div class="vss-modal" [ngClass]="{'show': isCreatingTicket}" id="vssCreateTicketModal">
    <div class="vss-modal-dialog">
      <div class="vss-modal-content">
        <!-- Modal Header -->
        <div class="vss-modal-header" style="border: 1px solid transparent;">
          <h3 class="vss-modal-title">{{isEditingTicket ? 'Edit Ticket' : 'Create Ticket'}}</h3>
          <button type="button" style="color: black;"  class="vss-close" (click)="closeCreateTicketModal()">&times;</button>
        </div>

        <!-- Modal Body (Ticket Form) -->
        <div class="vss-modal-body">
          <div class="col-xl-12">
            <form (ngSubmit)="submitTicketForm()" #ticketForm="ngForm" novalidate>
              <!-- Subject Field -->
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group"
                    [ngClass]="{'has-error': ticketForm.submitted && !ticket.subject}">
                    <label for="subject">Subject<span class="text-danger">*</span></label>
                    <input type="text" id="subject" class="form-controls"
                      [(ngModel)]="ticket.subject" name="subject" required>
                      @if (ticketForm.submitted && !ticket.subject) {
                        <div class="error-message">
                          Subject is required.
                        </div>
                      }
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group"
                      [ngClass]="{'has-error': ticketForm.submitted && !ticket.priority}">
                      <label for="priority">Priority</label>
                      <select id="priority" class="form-controls" [(ngModel)]="ticket.priority"
                        name="priority" required>
                        <option value="" disabled selected>Select Priority</option>
                        <option value="1">Low</option>
                        <option value="2">Medium</option>
                        <option value="3">High</option>
                        <option value="4">Urgent</option>
                      </select>
                      @if (ticketForm.submitted && !ticket.priority) {
                        <div class="error-message">
                          Priority is required.
                        </div>
                      }
                    </div>
                  </div>
                </div>

                <!-- Priority Field -->
                <div class="row">
                  <div class="col-lg-6">
                    <!-- Status Field -->
                    <div class="form-group"
                      [ngClass]="{'has-error': ticketForm.submitted && !ticket.status}">
                      <label for="status">Status</label>
                      <select id="status" class="form-controls" [(ngModel)]="ticket.status"
                        name="status" required>
                        <option value="" disabled selected>Select Status</option>
                        <option value="2">Open</option>
                        <option value="3">Pending</option>
                        <option value="4">Resolved</option>
                        <option value="5">Closed</option>
                      </select>
                      @if (ticketForm.submitted && !ticket.status) {
                        <div class="error-message">
                          Status is required.
                        </div>
                      }
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <!-- CC Emails Field -->
                    <div class="form-group"
                      [ngClass]="{'has-error': ccEmailError}">
                      <label for="ccEmails">CC Emails</label>
                      <input type="text"
                        id="ccEmails"
                        class="form-controls"
                        [(ngModel)]="currentCcInput"
                        name="ccEmailsInput"
                        placeholder="Enter CC email and press Enter"
                        (input)="onCcInputChange()"
                        (keydown)="handleCcKeydown($event)"
                        (blur)="handleCcBlur($event)" />
                      @if (ccEmailError) {
                        <div class="error-message">
                          {{ ccEmailError }}
                        </div>
                      }
                    </div>
                    <div class="cc-tags">
                      @for (email of ticket.cc_emails; track email; let i = $index) {
                        <span class="d-flex flex-row flex-wrap cc-tag">
                          {{ email }}
                          <span class="remove" (click)="removeCcEmail(i)">×</span>
                        </span>
                      }
                    </div>
                  </div>
                </div>
                <!-- Description Field with Quill Editor -->
                <div class="row">
                  <div class="col-lg-12">
                    <div class="form-group"
                      [ngClass]="{'has-error': ticketForm.submitted && !ticket.description}">
                      <label for="description">Description<span class="text-danger">*</span></label>
                      <div id="quill-editor-container">
                        <div id="quill-editor" style="height: 200px; background: white; border: 1px solid #ddd; border-radius: 4px;"></div>
                      </div>
                      @if (ticketForm.submitted && !ticket.description) {
                        <div class="error-message">
                          Description is required.
                        </div>
                      }
                    </div>
                  </div>
                </div>


                <!-- Submit and Cancel Buttons -->
                <div class="row" style="margin-top: 20px;">
                  <div class="col-lg-12">
                    <div class="d-flex" style="justify-content:center;">
                      <button type="submit" class="submitbtn" [disabled]="!ticketForm.form.valid || isSubmittingTicket || isCcPending"
                        (click)="createTicket()">
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <!-- Submitting overlay -->
          @if (isSubmittingTicket) {
            <div class="vss-submit-overlay">
              <mat-progress-spinner class="mat-spinner-color" mode="indeterminate" diameter="48"></mat-progress-spinner>
              <p style="margin-top:12px;color:#555;font-size:14px;">
                {{ isEditingTicket ? 'Updating ticket...' : 'Creating ticket...' }}
              </p>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Loading Spinner -->
    @if (isLoading) {
      <div id="spinner">
        <mat-progress-spinner class="mat-spinner-color" mode="indeterminate"></mat-progress-spinner>
      </div>
    }

    <!-- ======================================================== -->
    <!-- 1. SYSTEM SUPER ADMIN FRESHDESK VIEW                     -->
    <!-- ======================================================== -->
    @if (isSuperAdmin) {
      
      <!-- A. LIST VIEW (Screenshot 1) -->
      @if (!selectedTicket) {
        <div class="freshdesk-list-view" (click)="closeAllRowDropdowns()">
          <!-- Main Content Area: Full Width List directly starting from sort by row -->
          <div class="fd-main-body">
            <div class="fd-tickets-container">
              
              <!-- List Header Controls with Selection Actions, Pagination, Sort By Dropdown & Active Filter Tags -->
              <div class="fd-list-header-row" [ngClass]="{'fd-header-has-selection': selectedTicketsCount > 0}">
                <div class="fd-header-left">
                  
                  <!-- Master Checkbox (Matching Freshdesk Screenshot) -->
                  <div class="fd-master-checkbox-container">
                    <input 
                      type="checkbox" 
                      class="fd-ticket-checkbox fd-master-checkbox" 
                      [checked]="isAllSelected" 
                      [indeterminate]="isPartiallySelected" 
                      (change)="toggleSelectAll($event)" 
                      title="Select all on this page"
                    />
                  </div>

                  @if (selectedTicketsCount > 0) {
                    <!-- Bulk Actions Toolbar (Matching Freshdesk Screenshot: Assign, Close, Delete) -->
                    <div class="fd-bulk-actions-toolbar">
                      <button type="button" class="fd-bulk-action-btn" (click)="openBulkAssignModal()">
                        <i class="fa fa-user-plus"></i> Assign
                      </button>

                      <button type="button" class="fd-bulk-action-btn" [disabled]="isBulkUpdating" (click)="bulkCloseSelectedTickets()">
                        <i class="fa fa-check-circle"></i> Close
                      </button>

                      <button type="button" class="fd-bulk-action-btn fd-bulk-btn-danger" [disabled]="isBulkUpdating" (click)="bulkDeleteSelectedTickets()">
                        <i class="fa fa-trash"></i> Delete
                      </button>

                      <span class="fd-bulk-selection-count">{{ selectedTicketsCount }} selected</span>
                      <button type="button" class="fd-bulk-clear-link" (click)="clearTicketSelection()">Cancel</button>
                    </div>
                  } @else {
                    <!-- Freshdesk Sort By Dropdown Component (Matching Screenshot) -->
                    <div class="fd-sort-container">
                      <span class="fd-sort-prefix">Sort by:</span>
                      <button type="button" class="fd-sort-select-btn" (click)="toggleSortDropdown()">
                        <span>{{ currentSortLabel }}</span>
                        <i class="fa fa-chevron-down fd-sort-chevron"></i>
                      </button>

                      @if (showSortDropdown) {
                        <div class="fd-sort-dropdown-menu" (click)="$event.stopPropagation()">
                          <!-- Sort Fields -->
                          <div class="fd-sort-menu-item" [ngClass]="{'active': sortByField === 'created_at'}" (click)="setSortBy('created_at')">
                            <span>Date created</span>
                            @if (sortByField === 'created_at') {
                              <i class="fa fa-check fd-sort-check"></i>
                            }
                          </div>
                          <div class="fd-sort-menu-item" [ngClass]="{'active': sortByField === 'due_by'}" (click)="setSortBy('due_by')">
                            <span>Due by time</span>
                            @if (sortByField === 'due_by') {
                              <i class="fa fa-check fd-sort-check"></i>
                            }
                          </div>
                          <div class="fd-sort-menu-item" [ngClass]="{'active': sortByField === 'updated_at'}" (click)="setSortBy('updated_at')">
                            <span>Last modified</span>
                            @if (sortByField === 'updated_at') {
                              <i class="fa fa-check fd-sort-check"></i>
                            }
                          </div>
                          <div class="fd-sort-menu-item" [ngClass]="{'active': sortByField === 'priority'}" (click)="setSortBy('priority')">
                            <span>Priority</span>
                            @if (sortByField === 'priority') {
                              <i class="fa fa-check fd-sort-check"></i>
                            }
                          </div>
                          <div class="fd-sort-menu-item" [ngClass]="{'active': sortByField === 'status'}" (click)="setSortBy('status')">
                            <span>Status</span>
                            @if (sortByField === 'status') {
                              <i class="fa fa-check fd-sort-check"></i>
                            }
                          </div>

                          <div class="fd-sort-menu-divider"></div>

                          <!-- Sort Direction -->
                          <div class="fd-sort-menu-item" [ngClass]="{'active': sortOrder === 'asc'}" (click)="setSortOrder('asc')">
                            <span>Ascending</span>
                            @if (sortOrder === 'asc') {
                              <i class="fa fa-check fd-sort-check"></i>
                            }
                          </div>
                          <div class="fd-sort-menu-item" [ngClass]="{'active': sortOrder === 'desc'}" (click)="setSortOrder('desc')">
                            <span>Descending</span>
                            @if (sortOrder === 'desc') {
                              <i class="fa fa-check fd-sort-check"></i>
                            }
                          </div>
                        </div>
                      }
                    </div>
                    
                    <!-- Applied Filter Badges -->
                    @if (appliedFilterCount > 0) {
                      <div class="fd-applied-chips-row">
                        @for (st of appliedFilters.statuses; track st) {
                          <span class="fd-applied-chip">
                            Status: {{ st }}
                            <span class="fd-chip-remove" (click)="removeStatusFilter(st)">&times;</span>
                          </span>
                        }
                        @for (pr of appliedFilters.priorities; track pr) {
                          <span class="fd-applied-chip">
                            Priority: {{ pr }}
                            <span class="fd-chip-remove" (click)="removePriorityFilter(pr)">&times;</span>
                          </span>
                        }
                        @if (appliedFilters.orgName) {
                          <span class="fd-applied-chip">
                            Org: {{ appliedFilters.orgName }}
                            <span class="fd-chip-remove" (click)="removeOrgFilter()">&times;</span>
                          </span>
                        }
                        @if (appliedFilters.requesterEmailValue) {
                          <span class="fd-applied-chip">
                            Email: {{ appliedFilters.requesterEmailValue }}
                            <span class="fd-chip-remove" (click)="removeEmailFilter()">&times;</span>
                          </span>
                        }
                        @if (appliedFilters.createdDateStart) {
                          <span class="fd-applied-chip">
                            Date: {{ appliedFilters.createdDateStart }}
                            <span class="fd-chip-remove" (click)="removeDateFilter()">&times;</span>
                          </span>
                        }
                        <button class="fd-clear-all-link" (click)="resetAllFilters()">Clear All</button>
                      </div>
                    }
                  }
                </div>

                <!-- Pagination Controls in Header (like Freshdesk Screenshot) -->
                <div class="fd-header-right fd-pagination-controls">
                  <span class="fd-pagination-text">{{ paginationRangeText }}</span>
                  <button 
                    class="fd-page-nav-btn" 
                    [disabled]="currentPage === 1" 
                    (click)="prevPage()"
                    title="Previous page">
                    <i class="fa fa-chevron-left"></i>
                  </button>
                  <button 
                    class="fd-page-nav-btn" 
                    [disabled]="currentPage >= totalPages" 
                    (click)="nextPage()"
                    title="Next page">
                    <i class="fa fa-chevron-right"></i>
                  </button>
                </div>
              </div>

              <!-- Empty State -->
              @if (paginatedTicketsList.length === 0 && !isLoading) {
                <div class="fd-empty-state">
                  <i class="fa fa-ticket-alt fd-empty-icon"></i>
                  <p>No tickets found matching your filter criteria.</p>
                  <button class="fd-btn fd-btn-outline" (click)="resetAllFilters()">Clear Filters</button>
                </div>
              }

              <!-- Paginated Tickets List -->
              <div class="fd-tickets-list">
                @for (ticket of paginatedTicketsList; track ticket.id) {
                  <div class="fd-ticket-card" [ngClass]="{'fd-card-selected': isTicketSelected(ticket)}" (click)="selectTicket(ticket)">
                    
                    <div class="fd-card-left">
                      <input 
                        type="checkbox" 
                        class="fd-ticket-checkbox" 
                        [checked]="isTicketSelected(ticket)" 
                        (click)="toggleTicketSelection(ticket, $event)" 
                      />
                      
                      <!-- Avatar Circle with Initial -->
                      <div class="fd-avatar" [ngStyle]="{'background-color': getAvatarColor(getRequesterDisplayName(ticket))}">
                        {{ getAvatarInitial(getRequesterDisplayName(ticket)) }}
                      </div>
                    </div>

                    <div class="fd-card-center">
                      <!-- Badges Row -->
                      <div class="fd-badges-row">
                        @if (isTicketOverdue(ticket)) {
                          <span class="fd-badge fd-badge-overdue">Overdue</span>
                        }
                        @if (ticket.orgId) {
                          <span class="fd-badge fd-badge-tag">org_id:{{ ticket.orgId }}</span>
                        }
                        <span class="fd-badge fd-badge-tag">org_name:{{ ticket.orgName || 'Certiplate' }}</span>
                      </div>

                      <!-- Subject / Title -->
                      <div class="fd-ticket-title">
                        <span class="fd-subject-text">{{ ticket.summary || 'Untitled Ticket' }}</span>
                        <span class="fd-ticket-id">#{{ ticket.id }}</span>
                      </div>

                      <!-- Meta Line -->
                      <div class="fd-ticket-meta">
                        <i class="fa fa-globe fd-meta-icon"></i>
                        <span class="fd-meta-name">{{ getRequesterDisplayName(ticket) }}</span>
                        <span class="fd-meta-dot">&middot;</span>
                        <span class="fd-meta-time">Created {{ getTimeAgo(ticket.createdDate) }}</span>
                        @if (isTicketOverdue(ticket)) {
                          <span class="fd-meta-dot">&middot;</span>
                          <span class="fd-meta-overdue"><i class="fa fa-clock-o"></i> {{ getOverdueDuration(ticket) }}</span>
                        }
                      </div>
                    </div>

                    <div class="fd-card-right">
                      <!-- Priority with Interactive Dropdown Popup -->
                      <div class="fd-action-dropdown-anchor">
                        <div class="fd-priority-indicator fd-interactive-indicator" (click)="toggleRowPriorityDropdown(ticket.id, $event)">
                          <span class="fd-priority-dot" [ngStyle]="{'background-color': getPriorityDotColor(ticket.priority)}"></span>
                          <span class="fd-priority-text">{{ ticket.priority }}</span>
                          <i class="fa fa-chevron-down fd-dropdown-icon" [ngClass]="{'fa-chevron-up': activePriorityDropdownTicketId === ticket.id, 'fa-chevron-down': activePriorityDropdownTicketId !== ticket.id}"></i>
                        </div>

                        @if (activePriorityDropdownTicketId === ticket.id) {
                          <div class="fd-row-dropdown-menu" (click)="$event.stopPropagation()">
                            @for (pr of ['Low', 'Medium', 'High', 'Urgent']; track pr) {
                              <div 
                                class="fd-row-dropdown-item" 
                                [ngClass]="{'selected': (ticket.priority || '').toLowerCase() === pr.toLowerCase()}" 
                                (click)="updateRowPriority(ticket, pr, $event)">
                                <div class="fd-row-dropdown-label">
                                  <span class="fd-priority-dot" [ngStyle]="{'background-color': getPriorityDotColor(pr)}"></span>
                                  <span>{{ pr }}</span>
                                </div>
                                @if ((ticket.priority || '').toLowerCase() === pr.toLowerCase()) {
                                  <i class="fa fa-check fd-dropdown-check"></i>
                                }
                              </div>
                            }
                          </div>
                        }
                      </div>

                      <!-- Status with Interactive Dropdown Popup -->
                      <div class="fd-action-dropdown-anchor">
                        <div class="fd-status-indicator fd-interactive-indicator" (click)="toggleRowStatusDropdown(ticket.id, $event)">
                          <i class="fa fa-code-branch fd-status-icon"></i>
                          <span class="fd-status-name">{{ ticket.status }}</span>
                          <i class="fa fa-chevron-down fd-dropdown-icon" [ngClass]="{'fa-chevron-up': activeStatusDropdownTicketId === ticket.id, 'fa-chevron-down': activeStatusDropdownTicketId !== ticket.id}"></i>
                        </div>

                        @if (activeStatusDropdownTicketId === ticket.id) {
                          <div class="fd-row-dropdown-menu" (click)="$event.stopPropagation()">
                            @for (st of ['Open', 'Pending', 'Resolved', 'Closed']; track st) {
                              <div 
                                class="fd-row-dropdown-item" 
                                [ngClass]="{'selected': (ticket.status || '').toLowerCase() === st.toLowerCase()}" 
                                (click)="updateRowStatus(ticket, st, $event)">
                                <div class="fd-row-dropdown-label">
                                  <span>{{ st }}</span>
                                </div>
                                @if ((ticket.status || '').toLowerCase() === st.toLowerCase()) {
                                  <i class="fa fa-check fd-dropdown-check"></i>
                                }
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>

                  </div>
                }
              </div>

            </div>
          </div>

        </div>
      }

      <!-- B. DETAIL VIEW (Dedicated TicketDetailComponent) -->
      @if (selectedTicket) {
        <app-ticket-detail 
          [ticket]="selectedTicket" 
          [isSuperAdmin]="isSuperAdmin"
          (backToList)="backToTicketList()"
          (ticketUpdated)="onTicketUpdated($event)"
          (editRequested)="editTicket($event)">
        </app-ticket-detail>
      }

    }

    <!-- ======================================================== -->
    <!-- 2. NORMAL USER VIEW (Standard Custom Table or Detail View)-->
    <!-- ======================================================== -->
    @if (!isSuperAdmin) {
      @if (selectedTicket) {
        <app-ticket-detail 
          [ticket]="selectedTicket" 
          [isSuperAdmin]="false"
          (backToList)="backToTicketList()"
          (ticketUpdated)="onTicketUpdated($event)"
          (editRequested)="editTicket($event)">
        </app-ticket-detail>
      } @else {
        <div class="ticket-table">
          <custom-table [tableData]="allCustomerCountsData" [tableColumns]="tableColumns" [tableActions]="tableActions" [isLoading]="isLoading"
            [moduleType]="'tickets'" [pageType]="'tickets'" isFilterPresent="true" hideTableTitle="true"
            (toogleEmitter)="updateStatus($event)" [filterAttributes]="filterAttributes"
            (tableActionEmitter)="addTicket()" (rowAction)="rowAction($event)">
          </custom-table>
        </div>
      }
    }

    <!-- ======================================================== -->
    <!-- 3. SMALL POPUP MODAL: BULK ASSIGN TICKET(S)              -->
    <!-- ======================================================== -->
    @if (showBulkAssignModal) {
      <div class="fd-assign-modal-overlay" (click)="closeBulkAssignModal()">
        <div class="fd-assign-popup-card" (click)="$event.stopPropagation()">
          <div class="fd-assign-popup-header">
            <h4 class="fd-assign-popup-title">
              Assign Ticket
            </h4>
            <button type="button" class="fd-assign-popup-close" (click)="closeBulkAssignModal()">&times;</button>
          </div>

          <form autocomplete="off" (submit)="submitBulkAssign(); $event.preventDefault();" name="assignTicketPopupForm" style="margin:0;">
            <div class="fd-assign-popup-body">
              <label class="fd-assign-popup-label">Assignee Email <span class="text-danger">*</span></label>
              <input 
                type="email" 
                name="isolated_assignee_email_field"
                id="isolated_assignee_email_field"
                autocomplete="new-password"
                autocorrect="off"
                spellcheck="false"
                class="form-controls fd-assign-popup-input" 
                placeholder="Enter assignee email (e.g. agent@company.com)" 
                [ngModel]="bulkAssigneeEmail" 
                (ngModelChange)="onBulkAssigneeEmailChange($event)"
                (keydown.enter)="submitBulkAssign()"
                (keydown)="$event.stopPropagation()"
                (input)="$event.stopPropagation()"
                autofocus
              />
              <p class="fd-assign-popup-hint">
                Selected tickets will be assigned and notification emails with ticket details will be dispatched.
              </p>
            </div>

            <div class="fd-assign-popup-footer">
              <button 
                type="submit" 
                class="fd-btn-grey" 
                [disabled]="isBulkUpdating || !bulkAssigneeEmail.trim()">
                {{ isBulkUpdating ? 'Assigning...' : 'Assign' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    }

    <!-- ======================================================== -->
    <!-- 4. SMALL POPUP MODAL: BULK DELETE CONFIRMATION           -->
    <!-- ======================================================== -->
    @if (showDeleteConfirmModal) {
      <div class="fd-assign-modal-overlay" (click)="closeDeleteConfirmModal()">
        <div class="fd-assign-popup-card fd-delete-popup-card" (click)="$event.stopPropagation()">
          <div class="fd-assign-popup-header">
            <h4 class="fd-assign-popup-title" style="color: #dc2626;">
              Confirm Delete
            </h4>
            <button type="button" class="fd-assign-popup-close" (click)="closeDeleteConfirmModal()">&times;</button>
          </div>

          <div class="fd-assign-popup-body">
            <p class="fd-delete-confirm-text">
              Are you sure you want to delete <strong>{{ selectedTicketsCount }}</strong> selected ticket{{ selectedTicketsCount > 1 ? 's' : '' }}?
            </p>
            <p class="fd-assign-popup-hint">
              This action will remove the selected ticket(s) from the active list.
            </p>
          </div>

          <div class="fd-assign-popup-footer">
            <button 
              type="button" 
              class="fd-btn fd-btn-danger" 
              [disabled]="isBulkUpdating" 
              (click)="confirmBulkDelete()">
              {{ isBulkUpdating ? 'Deleting...' : 'Delete' }}
            </button>
          </div>
        </div>
      </div>
    }

  </div>